import { Column } from "primereact/column";
import MeaLink from "../../../../components/MeaLink";
import useUrlState from "@ahooksjs/use-url-state";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  ToFormatedDateWithWeekday,
  ToFormatedHour,
  ToFormatedShortISODate,
} from "../../../../utils/dates";
import MeaButton from "../../../../components/MeaButton";
import MeaDataTable from "../../../../components/MeaDataTable";
import sessionsAPI from "../../../../services/sessions";
import { useNavigate } from "react-router-dom";
import MeaTeacherAvatar from "../../components/MeaTeacherAvatar";
import CreateSessionModal from "./CreateSessionModal";
import UpdateSessionModal from "./UpdateSessionModal";
import MeaAttendancesProgressBar from "../../components/MeaAttendancesProgressBar";
import classesAPI from "../../../../services/classes";
import coursesAPI from "../../../../services/courses";
import teachersAPI from "../../../../services/teachers";
import classroomsAPI from "../../../../services/classrooms";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { addLocale } from 'primereact/api';
import { PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_CLASSROOMS, PERMISSION_TRAINING_COURSES, PERMISSION_TRAINING_SESSIONS, PERMISSION_TRAINING_TASKS, PERMISSION_TRAINING_TEACHERS } from "../../../../permissions";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import MeaPermissionGuard from "../../../../components/MeaPermissionGuard";

const SessionsListContent = forwardRef((props, ref) => {
  const { selectedFields, filter, showFilterButton, showAddButton, showAllSessions = false, schoolId, trainingId, currentTeacherId, disableNavigation = false } = props;
  //
  const navigate = useNavigate();
  const { hasPermission } = useAuthContext();
  const accessToken = "";
  const canDeleteSessions = hasPermission(PERMISSION_TRAINING_SESSIONS.DELETE);
  const canUpdateSessions = hasPermission(PERMISSION_TRAINING_SESSIONS.UPDATE);
  //
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();
  //
  const createModalRef = useRef();
  const updateModalRef = useRef();
  //
  let selectedData = {
    slot: selectedFields?.slot ?? true,
    level: selectedFields?.level ?? true,
    classe: selectedFields?.classe ?? true,
    course: selectedFields?.course ?? true,
    teacher: selectedFields?.teacher ?? true,
    classroom: selectedFields?.classroom ?? true,
    presence: selectedFields?.presence ?? false,
    replacement: selectedFields?.replacement ?? false,
    presenceStatistics: selectedFields?.presenceStatistics ?? false,
    points: selectedFields?.points ?? true,
    edit: selectedFields?.edit ?? true,
  };
  //
  const today = ToFormatedShortISODate(new Date());
  const [state, setState] = useUrlState({
    sessionsFilter: JSON.stringify({
      slot_id: filter?.slot_id || "",
      level_id: filter?.level_id || "",
      classe_id: filter?.classe_id || "",
      course_id: filter?.course_id || "",
      teacher_id: filter?.teacher_id || "",
      classroom_id: filter?.classroom_id || "",
      start_date: filter?.start_date || filter?.day || today,
      end_date: filter?.end_date || filter?.day || today,
    }),
  });
  const [session, setSession] = useState(null);

  useEffect(() => {
    const nextFilter = {
      slot_id: filter?.slot_id || "",
      level_id: filter?.level_id || "",
      classe_id: filter?.classe_id || "",
      course_id: filter?.course_id || "",
      teacher_id: filter?.teacher_id || "",
      classroom_id: filter?.classroom_id || "",
      start_date: filter?.start_date || filter?.day || today,
      end_date: filter?.end_date || filter?.day || today,
    };
    const nextFilterString = JSON.stringify(nextFilter);

    if (state.sessionsFilter !== nextFilterString) {
      setState((s) => ({
        ...s,
        schedulePage: 1,
        sessionsFilter: nextFilterString,
      }));
    }
  }, [
    filter?.slot_id,
    filter?.level_id,
    filter?.classe_id,
    filter?.course_id,
    filter?.teacher_id,
    filter?.classroom_id,
    filter?.start_date,
    filter?.end_date,
    filter?.day,
    setState,
    state.sessionsFilter,
    today,
  ]);
  //
  //
  const queryList = sessionsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
    JSON.parse(state.sessionsFilter)
  );
  //
  const classesQuery = classesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const coursesQuery = coursesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const teachersQuery = teachersAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const classroomsQuery = classroomsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  //
  addLocale('fr', {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'],
    today: 'Aujourd\'hui',
    clear: 'Annuler'
  });
  //
  const setFilter = (field, value) => {
    let currentFilter = state?.sessionsFilter;
    let currentFilterObj = JSON.parse(currentFilter);
    currentFilterObj[field] = value;
    setState((s) => ({
      schedulePage: 1,
      sessionsFilter: JSON.stringify(currentFilterObj),
    }));
  };
  const setFilters = (filters) => {
    let currentFilter = state?.sessionsFilter;
    let currentFilterObj = JSON.parse(currentFilter);
    Object.keys(filters).forEach((key) => {
      currentFilterObj[key] = filters[key];
    });
    setState((s) => ({
      schedulePage: 1,
      sessionsFilter: JSON.stringify(currentFilterObj),
    }));
  };
  //
  const filterCombobox = (options, query, field) => {
    return (
      <Dropdown
        value={query?.data?.data?.find(
          (obj) => obj.id === JSON.parse(state.sessionsFilter)[field]
        )}
        options={query?.data?.data}
        optionLabel="name"
        onChange={(e) => {
          options.filterApplyCallback(e.value);
          setFilter(field, e.value?.id || "");
        }}
        //itemTemplate={statusItemTemplate}
        placeholder="Séléctionner"
        className="p-column-filter"
        showClear
      />
    );
  };
  //
  const whenOptions = [
    { id: "TODAY", name: "Aujourd'hui" },
    { id: "YESTERDAY", name: "Hier" },
    { id: "TOMORROW", name: "Demain" },
    { id: "SPECIFIC_DATE", name: "Date spécifique" }
  ];

  const calendarFilterDayValue = (() => {
    const currentFilter = JSON.parse(state.sessionsFilter);
    const dayValue = currentFilter["day"] || currentFilter["start_date"];

    if (!dayValue) {
      return null;
    }

    if (typeof dayValue === "string" && dayValue.includes("-")) {
      const [year, month, day] = dayValue.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    return new Date(dayValue);
  })();
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));

  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && (
        <div>
          <MeaButton
            label="Créer une session"
            icon="pi pi-plus"
            size="small"
            className="p-button mr-2 action"
            visible={false}
            onClick={() => {
              createModalRef.current.show(() => {
                queryList.refetch();
              });
            }}
            data-pr-tooltip="Nouvelle session"
            permission={PERMISSION_TRAINING_SESSIONS.CREATE}
          />
          <MeaButton
            label="Générer les sessions de cours"
            icon="pi pi-calendar-plus"
            size="small"
            className="p-button mr-2 action"
            outlined
            onClick={() => {
              navigate(`/school/${schoolId}/admin/trainings/${trainingId}/generate-sessions`);
            }}
            data-pr-tooltip="Generate"
            permission={PERMISSION_TRAINING_TASKS.GENERATE_SCHEDULE_SESSIONS}
          />
        </div>
      )}
    </div>
  );
  //
  const rowClass = (data) => {
    const startDate = new Date(data.event?.start_date);
    const endDate = new Date(data.event?.end_date);
    const todayDate = new Date();
    // Remove hours from comparison
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    todayDate.setHours(0, 0, 0, 0);
    return {
      'bg-blue-50': startDate.getTime() === todayDate.getTime(),
      'surface-ground': startDate < todayDate
    };
  };

  const getTeacherLabel = (teacher) => {
    if (!teacher) {
      return "";
    }

    return (
      teacher?.member?.name ||
      [teacher?.member?.lastname, teacher?.member?.firstname].filter(Boolean).join(" ")
    );
  };
  //
  return (
    <>
      <CreateSessionModal ref={createModalRef} schoolId={schoolId} trainingId={trainingId} />
      {selectedData.presenceStatistics && (
        <div className="grid">
          {/* 
        <div className="col-12 md:col-6 lg:col-3 p-3">
          <div className="p-3 text-center bg-gray-500 border-round">
            <div className="text-2xl font-medium text-white mb-2">12</div>
            <span className="text-gray-100 font-medium">Non définis</span>
          </div>
        </div>
        */}
          <div className="col-12 md:col-6 lg:col-4 p-3">
            <div className="p-3 text-center bg-green-500 border-round">
              <div className="text-2xl font-medium text-white mb-2">
                {queryList?.data?.extraMeta?.present_count || "-"}
              </div>
              <span className="text-green-100 font-medium">Présences</span>
            </div>
          </div>
          <div className="col-12 md:col-6 lg:col-4 p-3">
            <div className="p-3 text-center bg-orange-500 border-round">
              <div className="text-2xl font-medium text-white mb-2">
                {queryList?.data?.extraMeta?.late_count || "-"}
              </div>
              <span className="text-orange-100 font-medium">Retards</span>
            </div>
          </div>
          <div className="col-12 md:col-6 lg:col-4 p-3">
            <div className="p-3 text-center bg-red-500 border-round">
              <div className="text-2xl font-medium text-white mb-2">
                {queryList?.data?.extraMeta?.absent_count || "-"}
              </div>
              <span className="text-red-100 font-medium">Absences</span>
            </div>
          </div>
        </div>
      )}
      <MeaDataTable
        query={queryList}
        serviceAPI={sessionsAPI}
        names={{ pagination: "session", singular: "séance", plural: "séances" }}
        startToolbarTemplate={startToolbarTemplate}
        showFilter={false}
        showFilterButton={showFilterButton}
        showDeleteButton={canDeleteSessions}
        showSelection={canDeleteSessions}
        setPage={setPage}
        setPageSize={setPageSize}
        rowClassName={rowClass}
        schoolId={schoolId}
        trainingId={trainingId}
        paginatorPosition="bottom"
        showHeader={false}
      >
        {canDeleteSessions && (
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
          ></Column>
        )}
        {selectedData.slot && (
          <Column
            header="Séance"
            body={(session) => {
              const startDate = new Date(session?.event?.start_date);
              const formattedStartDate = ToFormatedDateWithWeekday(startDate);
              const formattedStartHour = ToFormatedHour(startDate);
              const endSate = new Date(session?.event?.end_date);
              const formattedEndHour = ToFormatedHour(endSate);
              return (
                <MeaLink
                  to={
                    "/school/" +
                    schoolId +
                    "/admin/trainings/" +
                    trainingId +
                    "/sessions/" +
                    session.id
                  }
                  permission={PERMISSION_TRAINING_SESSIONS.GET}
                  noNavigation={disableNavigation}
                >
                  {formattedStartDate} de {formattedStartHour} à{" "}
                  {formattedEndHour}
                </MeaLink>
              );
            }}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) => {
              return !showAllSessions && <Calendar locale="fr" value={calendarFilterDayValue} onChange={(e) => {
                const selectedDay = e.value ? ToFormatedShortISODate(e.value) : "";
                setFilters({ day: selectedDay, start_date: selectedDay, end_date: selectedDay });
              }} dateFormat="dd/mm/yy" />
            }}
          ></Column>
        )}
        {selectedData.classe && (
          <Column
            field="schedule_item.classe.name"
            header="Classe"
            body={(session) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/classes/" +
                  session?.schedule_item?.classe?.id
                }
                permission={PERMISSION_TRAINING_CLASSES.GET}
                noNavigation={disableNavigation}
              >
                {session?.schedule_item?.classe?.name}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, classesQuery, "classe_id")
            }
          ></Column>
        )}
        {selectedData.course && (
          <Column
            field="schedule_item.course.name"
            header="Matière"
            body={(session) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/courses/" +
                  session.schedule_item.course.id
                }
                permission={PERMISSION_TRAINING_COURSES.GET}
                noNavigation={disableNavigation}
              >
                {session.schedule_item.course.name}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, coursesQuery, "course_id")
            }
          ></Column>
        )}
        {selectedData.teacher && (
          <Column
            header="Enseignant(e)"
            body={(session) => (
              <MeaTeacherAvatar
                teacher={session?.teacher || session?.schedule_item?.teacher}
                substitute={session?.schedule_item?.teacher}
                permission={PERMISSION_TRAINING_TEACHERS.GET}
                schoolId={schoolId}
                trainingId={trainingId}
                noNavigation={disableNavigation}
              />
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) => {
              return (
                <Dropdown
                  value={JSON.parse(state.sessionsFilter)["teacher_id"] || ""}
                  options={teachersQuery?.data?.data?.map((item) => {
                    return {
                      label:
                        item.member?.name ||
                        item.member?.lastname + " " + item.member?.firstname,
                      value: item.id,
                    };
                  })}
                  onChange={(e) => {
                    options.filterApplyCallback(e.value);
                    setFilter("teacher_id", e.value || "");
                  }}
                  //itemTemplate={statusItemTemplate}
                  placeholder="Séléctionner"
                  className="p-column-filter"
                  showClear
                />
              );
            }}
          ></Column>
        )}
        {selectedData.classroom && (
          <Column
            field="classroom.name"
            header="Salle"
            body={(session) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/classrooms/" +
                  session?.classroom?.id
                }
                permission={PERMISSION_TRAINING_CLASSROOMS.GET}
                noNavigation={disableNavigation}
              >
                {session?.classroom?.name}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, classroomsQuery, "classroom_id")
            }
          ></Column>
        )}
        {selectedData.presence && (
          <Column
            header="Présence"
            body={(item) => (
              <MeaAttendancesProgressBar
                attendances={item?.attendances}
                showValues={false}
                showLegends={false}
              />
            )}
          ></Column>
        )}
        {selectedData.replacement && (
          <Column
            header="Remplacement"
            body={(session) => {
              const actualTeacherId = session?.teacher?.id || session?.teacher_id;
              const actualTeacher = session?.teacher || session?.schedule_item?.teacher;
              const scheduledTeacher = session?.schedule_item?.teacher;
              const scheduledTeacherId = scheduledTeacher?.id || session?.schedule_item?.teacher_id;

              if (!actualTeacherId || !scheduledTeacherId || actualTeacherId === scheduledTeacherId) {
                return "";
              }

              const actualTeacherLabel = getTeacherLabel(actualTeacher);
              const scheduledTeacherLabel = getTeacherLabel(scheduledTeacher);

              if (currentTeacherId && currentTeacherId === scheduledTeacherId) {
                return actualTeacherLabel ? `A été remplacé par ${actualTeacherLabel}` : "A été remplacé";
              }

              if (currentTeacherId && currentTeacherId === actualTeacherId) {
                return scheduledTeacherLabel ? `Remplacement de ${scheduledTeacherLabel}` : "Remplacement";
              }

              if (scheduledTeacherLabel) {
                return `Remplacement de ${scheduledTeacherLabel}`;
              }

              return "Remplacement";
            }}
          ></Column>
        )}
        {selectedData.points && (
          <Column
            field="points"
            header="Points"
            body={(session) =>
              new Intl.NumberFormat("fr-FR", {
                maximumFractionDigits: 2,
              }).format(session?.points ?? 0)
            }
            headerStyle={{ width: "8%", minWidth: "5rem" }}
            bodyStyle={{ textAlign: "right" }}
          ></Column>
        )}
        {selectedData.edit && canUpdateSessions && (
          <Column
            body={(item) => (
              <>
                <MeaButton
                  icon="pi pi-pencil"
                  rounded
                  text
                  style={{ padding: "0", height: "1.5rem" }}
                  aria-label="Filter"
                  onClick={() => {
                    setSession(item);
                    if (updateModalRef.current) {
                      updateModalRef.current.show(() => {
                        queryList.refetch();
                      });
                    }
                  }}
                  permission={PERMISSION_TRAINING_SESSIONS.UPDATE}
                />
              </>
            )}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        )}
      </MeaDataTable>
      <UpdateSessionModal ref={updateModalRef} session={session} />
    </>
  );
});

const SessionsListComponent = forwardRef((props, ref) => {
  const { schoolId, trainingId } = props;

  return (
    <MeaPermissionGuard
      permission={PERMISSION_TRAINING_SESSIONS.LIST}
      fallbackTo={`/school/${schoolId}/admin/trainings/${trainingId}/info`}
      hideOnMissingPermission={true}
    >
      <SessionsListContent {...props} ref={ref} />
    </MeaPermissionGuard>
  );
});

export default SessionsListComponent;
